const ITEMS = [
    "100% UPTIME",
    "SOPORTE 24/7",
    "MONITOREO ACTIVO",
    "SEGURIDAD EMPRESARIAL",
    "INFRAESTRUCTURA ESCALABLE",
    "INSTALACIÓN CERTIFICADA",
    "RESPUESTA < 30 MIN",
];

const Marquee = () => {
    const repeated = [...ITEMS, ...ITEMS, ...ITEMS, ...ITEMS];
    return (
        <div
            data-testid="marquee-strip"
            className="border-b border-white/10 bg-[#0a0a0a] py-5 overflow-hidden"
        >
            <div className="flex whitespace-nowrap animate-marquee no-scrollbar">
                {repeated.map((t, i) => (
                    <span
                        key={i}
                        className="flex items-center font-mono text-sm tracking-[0.3em] uppercase text-white/50 px-8"
                    >
                        <span className="text-[#1A9EC9] mr-8">◆</span>
                        {t}
                    </span>
                ))}
            </div>
        </div>
    );
};

export default Marquee;
